import * as qs from 'qs';
import * as queryString from 'query-string';
import * as Cookies from 'universal-cookie';
import axios, { AxiosRequestConfig } from 'axios';
import { Component, FormEvent } from 'react';
import { connect, Dispatch } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { AppActionCreators, AuthActionCreators, IApplicationState, IAuthState, IAppState } from '@nkr/store/index';
import { IAuthentication, IToken, IUser, ITokenResponse } from '@nkr/models/index';
import { AuthResult, AuthRole, OrganType } from '@nkr/enums/index';
import { Button, FormControl, Alert, FormGroup, HelpBlock, Checkbox, ControlLabel, Form, Col } from 'react-bootstrap';
import { LoadingIndicator } from '../loading-indicator';
import { Utility } from '@nkr/services/utility';
import MediaQuery from 'react-responsive';
import PasswordField from './password-field';
import ForgotCredentials from './forgot-credentials';

interface IOwnProps extends RouteComponentProps<{}> { }

interface IStateProps {
    app: IAppState,
    auth: IAuthState
}

interface IDispatchProps {
    storeAuth: (auth: IToken, tokenHex: string) => any,
    requestUserProfile: () => Promise<IUser>,
    setSite: (payload: { domain: string, organ: string, organType: OrganType }) => void
}

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;

interface IValidation {
    emailAddress: boolean,
    password: boolean,
    newPassword: boolean,
    newPasswordConfirm: boolean
}

interface IState {
    [index: string]: string | boolean | AuthResult | IValidation,

    showLoading: boolean,
    redirect: boolean,
    redirectPath: string,
    message: string,
    emailAddress: string,
    password: string,
    verificationCode: string,
    rememberThisBrowser: boolean,
    newPassword: string,
    newPasswordConfirm: string,
    authResult: AuthResult,
    validation: IValidation,
    forgotCredentials: boolean,
}

const initialState: IState = {
    showLoading: false,
    redirect: false,
    redirectPath: '/home',
    message: '',
    emailAddress: '',
    password: '',
    verificationCode: '',
    rememberThisBrowser: false,
    newPassword: '',
    newPasswordConfirm: '',
    authResult: AuthResult.Success,
    validation: {
        emailAddress: true,
        password: true,
        newPassword: true,
        newPasswordConfirm: true
    },
    forgotCredentials: false,
};

class Login extends Component<TProps, IState> {
    readonly state: IState = initialState;

    componentDidMount = () => {
        let parsed = queryString.parse(this.props.location.search);

        let domain = Utility.getRootDomain(window.location.href);
        let payload = domain.indexOf('kidney') >= 0 ? { domain, organ: 'kidney', organType: OrganType.Kidney } : { domain, organ: 'liver', organType: OrganType.Liver };

        this.props.setSite(payload);

        let redirectPath = parsed.next != null ? decodeURIComponent(parsed.next) : this.state.redirectPath;
        let forgotCredentials = parsed.token && parsed.username ? true : this.state.forgotCredentials;

        // if (parsed.next != null)
        //     this.setState({
        //         redirectPath: decodeURIComponent(parsed.next),
        //     });

        // if (parsed.token && parsed.username) {
        //     this.setState({
        //         forgotCredentials: true,
        //     });
        // }

        this.setState({
            redirectPath,
            forgotCredentials
        });
    }

    handleTextInputChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;

        this.setState({
            [name]: value
        });
    }

    handlePasswordChange = (name: string, value: string) => {
        this.setState({
            [name]: value
        });
    }

    handleRememberThisBrowserClick = () => {
        this.setState({
            rememberThisBrowser: !this.state.rememberThisBrowser
        });
    }

    handleLogin = (e: FormEvent<Form>) => {
        e.preventDefault();

        let cookies = new Cookies();
        let validation = this.validate();

        this.setState({
            validation
        }, () => {
            let { emailAddress, password, newPassword, newPasswordConfirm } = this.state.validation;
            let valid = emailAddress && password && newPassword && newPasswordConfirm;

            if (valid) {
                this.setState({
                    showLoading: true
                }, () => {
                    let login: IAuthentication = {
                        username: this.state.emailAddress,
                        password: this.state.password,
                        client_id: __CLIENTID__,
                        client_secret: __CLIENTSECRET__,
                        grant_type: 'password',
                        tfa_key: this.state.authResult == AuthResult.NeedsTwoFactorKey ? this.state.verificationCode : null,
                        save_browser: this.state.rememberThisBrowser,
                        new_password: this.state.authResult == AuthResult.NeedsPasswordUpdate ? this.state.newPassword : null,
                        new_password_confirm: this.state.authResult == AuthResult.NeedsPasswordUpdate ? this.state.newPasswordConfirm : null
                    };

                    let url = __API__ + '/token';

                    let postConfig: AxiosRequestConfig = {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        },
                        withCredentials: true
                    };

                    return axios.post(url, qs.stringify(login), postConfig)
                        .then((response: ITokenResponse) => {
                            let { success, token, tokenHex, authResult } = response.data;

                            if (success) {
                                this.props.storeAuth(token, tokenHex);

                                return this.props.requestUserProfile().then(user => {
                                    cookies.set('NkrAuth', { token: token, user: user }, { path: '/', domain: this.props.app.site.domain, secure: __ISSECURE__, httpOnly: false, sameSite: 'lax' });
                                    cookies.set('NkrSession', tokenHex, { path: '/', domain: this.props.app.site.domain, secure: __ISSECURE__, httpOnly: false, sameSite: 'lax' });
                                    cookies.set('NkrSite', { domain: this.props.app.site.domain, organ: this.props.app.site.organ, organType: this.props.app.site.organType }, { path: '/', domain: this.props.app.site.domain, secure: __ISSECURE__, httpOnly: false, sameSite: 'lax' });

                                    try {
                                        sessionStorage.setItem('NkrAuth', JSON.stringify({ token: token, user: user }));
                                        sessionStorage.setItem('NkrSession', tokenHex);
                                        sessionStorage.setItem('NkrSite', JSON.stringify({ domain: this.props.app.site.domain, organ: this.props.app.site.organ, organType: this.props.app.site.organType }));
                                    } catch (e) {}

                                    let redirectPath = this.state.redirectPath;
                                    let hasIldaAccess = user.roles.find(x => x.id == AuthRole.IldaAccessAll) != null;
                                    let hasDonorConnectAccess = user.roles.find(x => x.id >= AuthRole.DonorConnectAccessAll && x.id <= AuthRole.DonorConnectAccessReports) != null;

                                    switch (true) {
                                        case user.group.isNkdo:
                                            if (hasIldaAccess && hasDonorConnectAccess) {
                                                redirectPath = '/select-account';
                                            } else if (hasIldaAccess && !hasDonorConnectAccess) {
                                                redirectPath = '/ilda/to-do'
                                            } else {
                                                redirectPath = '/donor-connect/to-do'
                                            }

                                            break;

                                        case user.group.isCenter && user.isMicrositeCoach:
                                            redirectPath = '/select-account';
                                            break;

                                        case user.group.isCenter && !user.isMicrositeCoach:
                                            redirectPath = `/center/${user.centerId}`;
                                            break;

                                        case user.group.isLogisticsProvider:
                                            redirectPath = '/logistics/swaps';
                                            break;

                                        case user.group.isNkrLab:
                                            redirectPath = '/nkr-lab';
                                            break;

                                        case user.isMicrositeCoach:
                                            redirectPath = '/microsite/coach';
                                            break;

                                        case user.group.isOpo:
                                            redirectPath = '/opo';
                                            break;
                                    }

                                    this.setState({
                                        showLoading: false,
                                        redirectPath,
                                        redirect: true
                                    });
                                });
                            } else {
                                this.setState({
                                    showLoading: false,
                                    message: response.data.message,
                                    authResult
                                });
                            }
                        })
                        .catch((error: any) => {
                            this.setState({
                                showLoading: false,
                                message: error.message
                            });
                        });
                });
            }
        })
    }

    handleSwitchBetweenPasswordForms = () => {
        this.setState(prevState => ({
            forgotCredentials: !prevState.forgotCredentials
        }))
    }

    handleShowLoading = () => {
        this.setState({
            showLoading: true
        })
    }

    handleHideLoading = () => {
        this.setState({
            showLoading: false
        })
    }

    validate = () => {
        let validation: IValidation = {
            emailAddress: this.state.emailAddress != '',
            password: this.state.password != '',
            newPassword: this.state.authResult == AuthResult.NeedsPasswordUpdate ? this.state.newPassword != '' : true,
            newPasswordConfirm: this.state.authResult == AuthResult.NeedsPasswordUpdate ? this.state.newPasswordConfirm != '' : true,
        };

        return validation;
    }

    render = () => {
        const { emailAddress, password, newPassword, newPasswordConfirm } = this.state.validation;
        const valid = emailAddress && password && newPassword && newPasswordConfirm;

        if (this.state.redirect) {
            return <Redirect to={this.state.redirectPath} />;
        }

        return (
            <div className={'container-fluid ' + this.props.app.site.organ + 'registry-theme'}>
                <LoadingIndicator
                    type='spin'
                    color='black'
                    loading={this.state.showLoading}
                    message={'One moment please...'}
                />

                <MediaQuery minWidth={1025}>
                    {(matches) => {
                        const width = matches ? '40%' : '90%';

                        return (
                            <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, margin: 'auto', width, height: '50%' }}>
                                <div style={{ textAlign: 'center', marginBottom: 100 }}>
                                    <img src={`/images/${this.props.app.site.organ}registry-logo.png`} />
                                </div>

                                {!this.state.forgotCredentials &&
                                    <Form horizontal onSubmit={this.handleLogin} action='#' method='post'>
                                        {!valid && (
                                            <Alert bsStyle='danger'>There are some issues with your information...</Alert>
                                        )}

                                        {this.state.message != '' && (
                                            <Alert bsStyle='danger'>{this.state.message}</Alert>
                                        )}

                                        <FormGroup bsSize='lg'>
                                            <Col xs={12} lg={2} componentClass={ControlLabel}>Username</Col>
                                            <Col xs={12} lg={9}>
                                                <FormControl
                                                    name='emailAddress'
                                                    value={this.state.emailAddress}
                                                    onChange={this.handleTextInputChange}
                                                />

                                                {!this.state.validation.emailAddress && (
                                                    <HelpBlock>Please enter your email address</HelpBlock>
                                                )}
                                            </Col>
                                        </FormGroup>

                                        <FormGroup bsSize='lg'>
                                            <Col xs={12} lg={2} componentClass={ControlLabel}>Password</Col>
                                            <Col xs={12} lg={9}>
                                                <PasswordField
                                                    name='password'
                                                    size='lg'
                                                    value={this.state.password}
                                                    onChange={this.handlePasswordChange}
                                                />

                                                {!this.state.validation.password && (
                                                    <HelpBlock>Please enter your password</HelpBlock>
                                                )}
                                            </Col>
                                        </FormGroup>

                                        {this.state.authResult == AuthResult.NeedsTwoFactorKey && (
                                            <FormGroup bsSize='lg'>
                                                <Col xs={12} lg={2} componentClass={ControlLabel}>Verification Code</Col>
                                                <Col xs={12} lg={9}>
                                                    <FormControl
                                                        name='verificationCode'
                                                        value={this.state.verificationCode}
                                                        onChange={this.handleTextInputChange}
                                                    />

                                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                        <HelpBlock>Please enter the code we sent to your mobile #</HelpBlock>
                                                        <Checkbox style={{ marginTop: 5 }} checked={this.state.rememberThisBrowser} onClick={this.handleRememberThisBrowserClick}>Remember this browser</Checkbox>
                                                    </div>
                                                </Col>
                                            </FormGroup>
                                        )}

                                        {this.state.authResult == AuthResult.NeedsPasswordUpdate && (
                                            <>
                                                <FormGroup validationState={this.state.validation.newPassword ? null : 'error'}>
                                                    <Col xs={12} lg={2} componentClass={ControlLabel}>New Password</Col>
                                                    <Col xs={12} lg={9}>
                                                        <PasswordField
                                                            name='newPassword'
                                                            size='lg'
                                                            value={this.state.newPassword}
                                                            onChange={this.handlePasswordChange}
                                                        />

                                                        {this.state.validation.newPassword == false && (
                                                            <HelpBlock>Please specify your new password</HelpBlock>
                                                        )}
                                                    </Col>
                                                </FormGroup>

                                                <FormGroup validationState={this.state.validation.newPasswordConfirm ? null : 'error'}>
                                                    <Col xs={12} lg={2} componentClass={ControlLabel}>Confirm New Password</Col>
                                                    <Col xs={12} lg={9}>
                                                        <PasswordField
                                                            name='newPasswordConfirm'
                                                            size='lg'
                                                            value={this.state.newPasswordConfirm}
                                                            onChange={this.handlePasswordChange}
                                                        />

                                                        {this.state.validation.newPasswordConfirm == false && (
                                                            <HelpBlock>Please confirm your new password</HelpBlock>
                                                        )}
                                                    </Col>
                                                </FormGroup>
                                            </>
                                        )}

                                        <FormGroup>
                                            <Col xs={12} lg={2} componentClass={ControlLabel}></Col>
                                            <Col xs={12} lg={3}>
                                                <Button type='submit' bsStyle='primary' bsSize='lg'>Login</Button>
                                            </Col>
                                            <Col xs={12} lg={6} style={{ textAlign: 'right' }}>
                                                <Button bsStyle='link' bsSize='lg' onClick={this.handleSwitchBetweenPasswordForms}>Forgot Password? </Button>
                                            </Col>
                                        </FormGroup>
                                    </Form>
                                }

                                {this.state.forgotCredentials &&
                                    <ForgotCredentials
                                        onShowLoading={this.handleShowLoading}
                                        onHideLoading={this.handleHideLoading}
                                        onReturn={this.handleSwitchBetweenPasswordForms}
                                        history={this.props.history}
                                        location={this.props.location}
                                        match={this.props.match}
                                    />
                                }
                            </div>
                        );
                    }}
                </MediaQuery>
                <div style={{ position: 'fixed', bottom: 0, textAlign: 'center', width: '100%' }}>2019-{new Date().getFullYear()} Best Match Corporation dba National {this.props.app.site.organ.toLowerCase().replace(/\b\w/g, s => s.toUpperCase())} Registry. All rights reserved.</div>
            </div>
        )
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app,
        auth: state.auth
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        storeAuth: (auth, tokenHex) => {
            return dispatch(AuthActionCreators.storeAuth(auth, tokenHex));
        },
        requestUserProfile: () => {
            return dispatch(AppActionCreators.requestUserProfile());
        },
        setSite: (payload) => {
            return dispatch(AppActionCreators.setSite(payload));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(Login);
